// extracted by mini-css-extract-plugin
module.exports = {"header":"JUvEL","headerRightSide":"_3ki6P","pinnedIcon":"_27cC7","moreButton":"_15vhF"};